import { types } from '../actions/types'
import { types as sites } from '../actions/sites'
import { types as auth } from '../actions/auth'

const initialState = []

export default (dataType = 'type') =>
  (state = initialState, action) => {
    let index

    switch (action.type) {
      case sites.CHANGE:
        return [...action.data[`${dataType}s`]]

      case types.SAVE:
        if (action.data.dataType !== dataType) return state
        index = state.findIndex(v => v.id === action.data[dataType].id)
        if (index === -1) index = state.length

        return [
          ...state.slice(0, index),
          action.data[dataType],
          ...state.slice(index + 1)
        ]

      case types.DELETE:
        if (action.data.dataType !== dataType) return state
        index = state.findIndex(v => v.id === action.data[dataType].id)
        if (index === -1) return state

        return [
          ...state.slice(0, index),
          ...state.slice(index + 1)
        ]

      case auth.FAIL:
      case auth.LOGOUT:
        return initialState

      default:
        return state
    }
  }



// WEBPACK FOOTER //
// ./app/reducers/types.js